import VcsDetailsPage from "../../shared/VcsShared/components/VcsDetailsPage";

const OriginDetailsPage = VcsDetailsPage;

export default OriginDetailsPage;
